import React, { useEffect, useState } from "react";
import { ArrowLeft, ArrowRight } from "lucide-react";

import Button from "../app/Button";
import Radio from "../common/Radio";
import analytics from "src/helpers/analytics";
import { EVENT_NAMES, SCREEN_NAMES } from "src/helpers/analytics/events";
import { genderOptions } from "src/constants/common";

interface PatientGenderProps {
  title: string;
  description: string;
  value?: string;
  onBack: () => void;
  onNext: (gender: string) => void;
  support_program_key?: string;
}

const PatientGender: React.FC<PatientGenderProps> = ({
  title,
  description,
  value,
  onBack,
  onNext,
  support_program_key,
}) => {
  const [selected, setSelected] = useState<string | null>(
    (value as any) || null,
  );

  useEffect(() => {
    analytics.pageView(SCREEN_NAMES.GENDER_SELECTION_SCREEN);
  }, []);

  const handleContinue = () => {
    if (selected) {
      // Event: GENDER_SELECTED
      analytics.trackEvent(EVENT_NAMES.GENDER_SELECTED, {
        gender: selected,
        screen_name: SCREEN_NAMES.GENDER_SELECTION_SCREEN,
        support_program_key: support_program_key,
      });
      onNext(selected);
    }
  };

  return (
    <div className="flex flex-col flex-1 min-h-0">
      <div className="p-4 flex-1 min-h-0 overflow-y-auto">
        <button
          className="flex items-center gap-1 px-4 py-2 -ml-4"
          onClick={onBack}
        >
          <ArrowLeft className="w-4 h-4 text-gray-500" />
          <p className="text-sm text-gray-500">Back</p>
        </button>

        <div className="my-4">
          <h1 className="text-2xl font-bold text-[var(--text-primary)] mb-2">
            {title}
          </h1>
          <p className="text-[var(--text-secondary)]">{description}</p>
        </div>

        <ul className="flex flex-col gap-4">
          {genderOptions.map((opt) => (
            <li key={opt.value}>
              <button
                onClick={() => setSelected(opt.value as any)}
                className={`flex items-center gap-2 w-full text-left border rounded-lg px-4 py-3 bg-white ${
                  selected === opt.value
                    ? "border-[var(--app-primary)] bg-[var(--app-primary-bg)]"
                    : "border-gray-300"
                }`}
              >
                <Radio
                  checked={selected === opt.value}
                  onChange={() => setSelected(opt.value as any)}
                />
                <p className="font-medium text-[var(--text-primary)]">
                  {opt.label}
                </p>
              </button>
            </li>
          ))}
        </ul>
      </div>

      <div className="bg-white border-t border-gray-200 p-4 mt-auto">
        <Button fullWidth onClick={handleContinue} disabled={!selected}>
          <span className="flex items-center gap-2">
            Continue
            <ArrowRight className="w-4 h-4" />
          </span>
        </Button>
      </div>
    </div>
  );
};

export default PatientGender;
